var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showHourTrading)?_c('HourTradingDetail',{attrs:{"stock":_vm.stock}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }